/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { RecurringJob } from '@src/app/model/recurring-job';

@Injectable({
  providedIn: 'root'
})
export class RecurringJobService extends AbstractHttpService {
  protected http = inject(HttpClient);
  protected messageService = inject(MessageService);


  protected get baseUrl() {
    return this.getAjaxPath('crm/recurringJobs');
  }

  protected cache: RecurringJob[];
  protected typeString = 'RecurringJob';
}
